import type { FC, ReactNode } from 'react'

import { delay } from '@/lib/ui'
import { SplitWords } from '@/components/generals/split-words'

export const ContactMasthead: FC = (): ReactNode => {
    return (
        <section id='contact-intro' className='ed-wrap pt-[clamp(118px,19vh,190px)]'>
            <div className='ed-label' data-reveal='up'>
                (01) — Contact
            </div>

            <h1 className='ed-display mt-[clamp(30px,5vh,68px)]' data-reveal='words'>
                <span className='block'>
                    <SplitWords text='Tell us' />
                </span>

                <span className='block'>
                    <SplitWords text='where to stand' delay={0.09} />
                </span>
            </h1>

            <div className='mt-[clamp(34px,5vh,64px)] grid gap-y-10 md:grid-cols-12 md:gap-x-[clamp(20px,3vw,48px)]'>
                <div className='md:col-span-6 md:col-start-7'>
                    <p className='ed-lead' data-reveal='up'>
                        Commissions, print sales, licensing and exhibition loans.
                    </p>

                    <p className='ed-body mt-[clamp(20px,2.4vw,34px)]' data-reveal='up' style={delay(0.08)}>
                        Everything gets an answer within two working days, including the ones we have to turn
                        down. If it is a commission, the more you can tell us about the place and the season,
                        the more useful our first reply will be.
                    </p>
                </div>
            </div>
        </section>
    )
}
